/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=b2dc2d74&scoped=true"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
import style0 from "./icon.vue?vue&type=style&index=0&id=b2dc2d74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dc2d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2dc2d74')) {
      api.createRecord('b2dc2d74', component.options)
    } else {
      api.reload('b2dc2d74', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=b2dc2d74&scoped=true", function () {
      api.rerender('b2dc2d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icon/icon.vue"
export default component.exports